import React from 'react';
import { motion } from 'framer-motion';

const AcadGarage = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 40 },
    animate: { opacity: 1, y: 0 },
  };

  return (
    <div className="bg bg-slate-900 overflow-hidden text-white">
      {/* Hero Section */}
      <section className="flex items-center justify-center h-screen">
        <div className="max-w-4xl mx-auto px-4">
          <motion.h1
            className="text-4xl font-bold text-center mb-8"
            variants={fadeInUp}
            initial="initial"
            animate="animate"
          >
            Welcome to AcadGarage
          </motion.h1>
          <motion.p
            className="text-lg text-center text-gray-700"
            variants={fadeInUp}
            initial="initial"
            animate="animate"
            transition={{ delay: 0.2 }}
          >
            We help students turn their ideas into reality at affordable pricing.
          </motion.p>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-white">
        <div className=" mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">
            Our Services
          </h2>
          <div className="flex w-10/12 mx-auto gap-6 flex-wrap md:flex-nowrap ">
            <motion.div
              className="bg-white p-6 rounded-lg shadow-xl"
              variants={fadeInUp}
              initial="initial"
              animate="animate"
              transition={{ delay: 0.3 }}
            >
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                College Mini Projects
              </h3>
              <p className="text-gray-700">
                We offer assistance in developing college mini projects with the latest technologies and frameworks.
              </p>
            </motion.div>
            <motion.div
              className="bg-white p-6 rounded-lg shadow-xl"
              variants={fadeInUp}
              initial="initial"
              animate="animate"
              transition={{ delay: 0.4 }}
            >
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                Mobile App Development
              </h3>
              <p className="text-gray-700">
                Our team can build custom mobile applications for iOS and Android platforms to bring your ideas to life.
              </p>
            </motion.div>
            <motion.div
              className="bg-white p-6 rounded-lg shadow-xl"
              variants={fadeInUp}
              initial="initial"
              animate="animate"
              transition={{ delay: 0.5 }}
            >
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                Website Development
              </h3>
              <p className="text-gray-700">
                Get your own professional website designed and developed by our skilled web development team.
              </p>
            </motion.div>
          </div>
          </div>
          </section>

{/* Contact Footer */}
<footer className="py-16 text-center bg-gray-900">
  <div className="max-w-4xl mx-auto px-4">
    <motion.h2
      className="text-3xl text-center font-bold text-white mb-8"
      variants={fadeInUp}
      initial="initial"
      animate="animate"
    >
      Contact Us
    </motion.h2>
    <div className="flex items-center justify-center">
      <motion.p
        className="text-lg text-gray-400"
        variants={fadeInUp}
        initial="initial"
        animate="animate"
        transition={{ delay: 0.2 }}
      >
        Have a question or want to discuss your project? Reach out to us:
      </motion.p>
    </div>
    <div className="mt-8">
      <motion.a
        href="mailto:info@acadgarage.com"
        className="text-white text-lg"
        variants={fadeInUp}
        initial="initial"
        animate="animate"
        transition={{ delay: 0.3 }}
      >
        devignx@gmail.com
      </motion.a>
    </div>
  </div>
</footer>
</div>
);
};

export default AcadGarage;
